import { formatterAreadResult } from '../utils/tools'
import { omit } from 'lodash'
// 拉平的树对象
let areaTreeMap = {}

const JUMP_KEY = 'regionType'

export function isJumpNextLevel (item) {
  const node = item ? getAreaTreeNodeById(item.districtID) : {}
  return node && node[JUMP_KEY] && [1, 2].includes(+node[JUMP_KEY])
}

export function getLastSubstringAfterDash(str) {
  const match = String(str).match(/[^-]*$/)
  return match ? match[0] : str
}


// DistrictLevel 转 level
export function transformDistrictLevelToLevel (districtLevel) {
  switch (districtLevel) {
    case 'region':
      return '1'
    case 'province':
      return '2'
    case 'city':
      return '3'
    case 'zone':
      return '4'
    case 'country':
      return '4'
    case 'street':
      return '5'
    default:
      return districtLevel
  }
}

export function setAreaTreeRootNode (result) {
  if (result) {
    areaTreeMap[result.districtID] = result
  }
}

export function createParentItem (treeItem) {
  const {
    districtID,
    districtName,
    regionType,
    shortName,
    emptyLevel,
    level
  } = treeItem || {}
  return { districtID, districtName, regionType, emptyLevel, shortName, level }
}

// 将数据存储到本地 flatTreeMap中，并存储祖先路径
export function cookingAreaTreeNode (result, parents = []) {
  for (let i = 0; i < result.length; i++) {
    const treeItem = result[i]
    const {
      districtID,
      childrenNode = [],
      adminName
    } = treeItem

    const level = treeItem.level || transformDistrictLevelToLevel(treeItem.districtLevel)
    const parentIds = parents.map(ele => ele.districtID)
    const parentNames = parents.map(ele => ele.districtName)
    // 如果不存在则追加进去
    if (!areaTreeMap.hasOwnProperty(districtID) || !areaTreeMap[districtID]) {
      const parentName = parentNames[parentNames.length - 1]
      const parentId = parentIds[parentIds.length - 1]
      const parentNode = areaTreeMap[parentId]
      areaTreeMap[districtID] = {
        parentId,
        parentName,
        parentIds,
        parentNames,
        parents,
        ...treeItem,
        level,
        adminName: adminName || (isJumpNextLevel(parentNode) ? parentNode.shortName : '') // // 兜底 如果是特殊的，则使用父级的shortName 因为直接点中山的时候，id接口的 adminName 和 shortName 都是空
      }
    }
    if (childrenNode && childrenNode.length) {
      areaTreeMap = {
        ...areaTreeMap,
        ...cookingAreaTreeNode(childrenNode, [...parents, createParentItem(treeItem)])
      }
    }
  }
  return areaTreeMap
}

export const REGION_ORDER_IDS = [ // 大区渲染的数据ID。
  'XZ1-11', // 吉林
  'XZ1-21', // 海南
  'XZ1-22', // 浙江
  'XZ1-10', // 宁夏
]

// 渲染面板的节点。数据源是，从 flatTreeMap中 获取。 没有就调用 接口。然后添加到本地。有则是取兄弟节点
export function createPanelRenderDataByIds ({ids = REGION_ORDER_IDS, unshiftParent}) {
  const data = ids.reduce((acc, id) => {
    const treeItem = areaTreeMap[id]
    if (treeItem) {
      const { parentId } = treeItem
      const siblingNodes = Object.keys(areaTreeMap).reduce((arr, key) => {
        if (areaTreeMap[key].parentId === parentId) {
          arr.push(areaTreeMap[key])
        }
        return arr
      }, [])
      const parent = areaTreeMap[parentId]
      if (unshiftParent && parent) {
        siblingNodes.unshift({
          _isLabel: true,
          ...parent
        })
      }
      acc.push(siblingNodes)
    }
    return acc
  }, [])
  return data
}

// 是否存在节点
export function hasAreaTreeNode (id) {
  return areaTreeMap.hasOwnProperty(id) && !!areaTreeMap[id]
}

// 获取参数id的父节点
export function getAreaTreeParentNode (id) {
  const node = areaTreeMap[id]
  if (!node) {
    return null
  }
  const parentNode = areaTreeMap[node.parentId]
  return parentNode
}

// 获取参数id的子节点
export function getAreaTreeNodeChildren (id) {
  const keys = Object.keys(areaTreeMap)
  const children = keys.reduce((acc, key) => {
    const node = areaTreeMap[key]
    const { parentId } = node
    if (parentId === id) {
      acc.push(node)
    }
    return acc
  }, [])
  return children.length ? children : null
}

// 获取当前id对应树的节点
export function getAreaTreeNodeById (id) {
  return areaTreeMap[id]
}

// 获取当前id对应树的第一个子节点
export function getAreaTreeNodeFirstChid (id) {
  const keys = Object.keys(areaTreeMap)
  let child = null
  for (let i = 0; i < keys.length; i++) {
    const _id = keys[i]
    if (areaTreeMap[_id].parentId === id) {
      child = areaTreeMap[_id]
      break
    }
  }
  return child
}

// 获取大区渲染数据。这里就是不做任何操作和首屏或者点击省份时，面板需要渲染的数据
export function createAreaPanelBaseData () {
  const data = createPanelRenderDataByIds({unshiftParent: true, ids: [...REGION_ORDER_IDS]})
  return data
}

function createResultKeyMap (item) {
  if (!item) {
    return
  }
  const map = {}
  const { districtLevel, districtID, districtName, zoneCode, regionType, adminCode } = item
  map[districtLevel] = getLastSubstringAfterDash(districtName)
  map[districtLevel + 'Id'] = districtID
  map[districtLevel + 'Code'] = zoneCode
  map[districtLevel + 'Type'] = regionType
  map[districtLevel + 'AdminCode'] = adminCode
  return map
}

const OMIT_KEYS = ['parentId', 'parentName', 'parentIds', 'parentNames', 'parents']
export function transFormConfirmData (data, inputLabel) {
  try {
    if (!data) {
      return null
    }
    const { parents = [] } = data || {}
    let areaFullName = ''
    let areaFullId = ''
    const parentResult = parents.reduce((result, node) => {
      const { level, districtID, districtName } = node
      if (level > 1) {
        result = {
          ...result,
          ...createResultKeyMap(areaTreeMap[districtID])
        }
        areaFullName += getLastSubstringAfterDash(districtName)
        areaFullId += (districtID + ',')
      }
      return result
    }, {})
    areaFullName += getLastSubstringAfterDash(data.districtName)
    areaFullId += data.districtID
    const selfResult = createResultKeyMap(data)
    const areaIdNameMap = formatterAreadResult(data, false)
    const res = {
      ...data,
      ...selfResult,
      ...parentResult,
      ...areaIdNameMap,
      areaFullName,
      areaFullId,
      areaName: inputLabel
    }
    // 去掉内部的扩展字段
    const omitResult = omit(res, OMIT_KEYS)
    // console.log(omitResult, '-----transFormConfirmData----')
    return omitResult
  } catch (error) {
    return data
  }
}

export function getAreaTreeMap () {
  return areaTreeMap
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/data/store.js